"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.FAQ_MODULE_NAME = exports.FAQ_LAYOUT_TITLE = exports.FAQ_LAYOUT = void 0;
const FAQ_MODULE_NAME = exports.FAQ_MODULE_NAME = 'EditorialFrequentlyAskedQuestions';
const FAQ_LAYOUT = exports.FAQ_LAYOUT = 'faq-layout';
const FAQ_LAYOUT_TITLE = exports.FAQ_LAYOUT_TITLE = 'faq-layout-title';
